// src/hooks/useServices.js
import { useState, useEffect, useCallback } from 'react';

const FALLBACK = {
  packages: [],
  addons: [],
  monthlyFee: 75,
};

export function useServices() {
  const [services, setServices] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('/api/services');
      if (res.ok) {
        const data = await res.json();
        setServices({
          packages: data.packages || [],
          addons: data.addons || [],
          monthlyFee: data.monthlyFee ?? FALLBACK.monthlyFee,
        });
      }
    } catch {
      // fall back
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { services, loading, refresh, setServices };
}
